export const visit = {
  path: '/form-visit',
  name: 'visit',
  hidden: false,
  component: () => import('@/components/visitForm/index'),
  meta: {
    title: 'Kunjungan',
    icon: 'fa-server',
    roles: ['pasien']
  },
  children: [{
    path: 'data_kunjungan',
    name: 'DataKunjungan',
    hidden: true,
    meta: {
      title: 'Data kunjungan',
      icon: 'fa-area-chart',
      roles: ['pasien']
    },
    component: () => import('@/components/visitForm/components/MasterData')
  },
  {
    path: 'form_kunjungan',
    name: 'formKunjungan',
    hidden: true,
    meta: {
      title: 'Form kunjungan',
      icon: 'fa-area-chart',
      roles: ['pasien']
    },
    component: () => import('@/components/visitForm/components/FormKunjungan')
  },
  ]
}
export default visit





// WEBPACK FOOTER //
// ./src/router/modules/formVisit.js